import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { Fab } from '@material-ui/core';
import { useStyles } from "./styles.js";
export const Social = ({
  background,
  to,
  Icon,
  size,
  iconSize
}) => {
  const classes = useStyles({
    background
  });
  return /*#__PURE__*/React.createElement("a", {
    href: to,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(Fab, {
    size: size,
    className: classes.social
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    size: iconSize,
    icon: Icon
  })));
};
Social.defaultProps = {
  name: 'linkedin',
  to: 'https://www.linkedin.com/company/blackbox-vision/',
  Icon: faLinkedin,
  background: 'rgb(0, 119, 181)',
  size: 'medium',
  iconSize: '2x'
};
Social.displayName = 'Social';
export default Social;